import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Store } from '../../store';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { StoreService } from '../../store.service';

@Component({
  selector: 'app-edit-store-form',
  templateUrl: './edit-store-form.component.html',
  styleUrls: ['./edit-store-form.component.scss'],
})
export class EditStoreFormComponent implements OnInit {
  @Input() store: Store | undefined;
  @Output() updatedStore = new EventEmitter<Store>();
  updateStoreForm: UntypedFormGroup = new UntypedFormGroup({
    store: new UntypedFormControl(''),
  });
  buttonLabel = 'Mettre à jour';
  submitted = false;

  constructor(private readonly storeService: StoreService) {}

  ngOnInit(): void {
    const values = {
      name: this.store?.name,
      description: this.store?.description,
      imageInput: this.store?.image,
    };

    this.updateStoreForm.controls['store'].setValue(values);
  }

  submitUpdatedStore() {
    if (this.updateStoreForm?.valid) {
      this.submitted = true;
      const productForm = this.updateStoreForm.get('store')?.value;
      const updatedStore: Store = {
        id: this.store?.id,
        name: productForm.name,
        description: productForm.description,
        image: productForm.imageInput,
        active: false,
      };
      this.storeService.updateOne(updatedStore).subscribe((store) => {
        this.submitted = false;
        this.updatedStore.emit(store);
      });
    }
  }
}
